<template>
  <span
    :class="{
      'badge--error': type === 'error',
      'badge--success': type === 'success'
    }"
    class="badge"
  >
    <slot/>
  </span>
</template>

<script>
export default {
  name: 'CBadge',

  props: {
    type: {
      type: String,
      validator (value) {
        return [
          'error',
          'success'
        ].indexOf(value) >= 0
      }
    }
  }
}
</script>

<style scoped>
.badge {
  display: inline-block;
  padding: 6px 12px;
  vertical-align: middle;

  line-height: 1;
  letter-spacing: 0.05em;
  text-align: center;
  text-transform: uppercase;
  color: #fff;

  background: var(--color-brand);
  border-radius: 14px;
}

.badge--error {
  background-color: var(--color-error);
}

.badge--success {
  background-color: var(--color-success);
}
</style>
